import clsx from 'clsx';
import { TrackedSection } from '@objectiv/tracker-react';
import { HeadingProvider } from '~components/Heading';
import { ImageProvider } from '~components/Image/ImageProvider';

import * as styles from './Section.module.css';

import type { Layout } from '~models/contentful';
import type { SectionProps } from './types';

export const Section: React.FC<SectionProps> = ({
  children,
  className,
  style,
  as: Component = TrackedSection,
  theme,
  blockLayout = 'full-width',
  headingBaseLevel,
  imageLoadingStrategy = 'lazy',
  imageFetchPriority = 'low',
  verticalPadding = 'll',
  trackingId,
  id,
}) => (
  <Component
    data-theme={theme}
    className={clsx(styles.section, getLayoutClassName(blockLayout), styles[verticalPadding], className)}
    style={style}
    objectiv={{ id: trackingId, normalizeId: false }}
    id={id}
  >
    <HeadingProvider baseLevel={headingBaseLevel}>
      <ImageProvider loading={imageLoadingStrategy} fetchPriority={imageFetchPriority}>
        {children}
      </ImageProvider>
    </HeadingProvider>
  </Component>
);

const getLayoutClassName = (blockLayout?: Layout | null): string => {
  switch (blockLayout) {
    case 'boxed':
      return styles.boxed;
    case 'full-width':
    default:
      return styles.fullWidth;
  }
};
